"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseUserDto = void 0;
class BaseUserDto {
    constructor(baseUserDto) {
        this.id = baseUserDto.id;
        this.firstName = baseUserDto.firstName;
        this.lastName = baseUserDto.lastName;
    }
    get displayName() {
        return `${this.firstName ?? ''} ${this.lastName ?? ''}`;
    }
}
exports.BaseUserDto = BaseUserDto;
